import React from 'react'
import PropTypes from 'prop-types'
import WrappedDrawer from '@/components/WrappedDrawer'
import CustomerDetailContent from './CustomerDetailContent'

class CustomerDetailDrawer extends React.Component {
  static propTypes = {
    baseProps: PropTypes.object,
    title: PropTypes.string,
    width: PropTypes.number
  }

  handleClose = () => {
    const { baseProps } = this.props
    const { onClose } = baseProps || {}
    if (onClose) {
      onClose()
    }
  }

  render() {
    const { children, baseProps, title } = this.props
    const { customerId, onClose } = baseProps || {}

    const baseComponent = (
      <CustomerDetailContent
        customerId={customerId}
      />
    )

    return (
      <WrappedDrawer
        children={children}
        baseProps={{ ...baseProps }}
        baseComponent={baseComponent}
        title={title || '客户详情'}
        width={900}
        footer={null}
        maskClosable={true}
        onClose={onClose || this.handleClose}
      />
    )
  }
}

export default CustomerDetailDrawer

